import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { useLocalization } from '@/hooks/useLocalization';
import MobileStepper from '@mui/material/MobileStepper';
import { StepsForManual } from '../useAddAccountNavigation';

interface AddAccountProgressBarProps {
  activeStep: StepsForManual;
}

export default function AddAccountProgressBar({
  activeStep,
}: AddAccountProgressBarProps) {
  const { t } = useLocalization();

  const steps = [
    {
      step: StepsForManual.MANUAL_ACCOUNT_TYPE,
      label: t('addAccountModal.progressBar.accountType'),
    },
    {
      step: StepsForManual.MANUAL_ACCOUNT_DETAILS,
      label: t('addAccountModal.progressBar.accountDetails'),
    },
    {
      step: StepsForManual.MANUAL_PORTFOLIO_DIVERSIFICATION,
      label: t('addAccountModal.progressBar.portfolio'),
    },
    {
      step: StepsForManual.MANUAL_HISTORICAL_VALUES,
      label: t('addAccountModal.progressBar.historicalValues'),
    },
  ];

  const activeIndex = steps.findIndex((x) => x.step === activeStep);

  return (
    <Box>
      <Box sx={{ display: { xs: 'block', sm: 'none' }, marginBottom: 2 }}>
        <MobileStepper
          variant='dots'
          steps={steps.length}
          position='static'
          activeStep={activeIndex}
          sx={{
            background: 'none',
            '& .MuiMobileStepper-dots': {
              display: 'flex',
              justifyContent: 'center',
              background: 'none',
              gap: '1rem',
            },
            '& .MuiMobileStepper-dot': {
              width: '1rem',
              height: '1rem',
            },
          }}
          backButton={null}
          nextButton={null}
        />
      </Box>

      <Box sx={{ display: { xs: 'none', sm: 'block' }, marginBottom: 4 }}>
        <Stepper
          activeStep={activeIndex}
          sx={{
            '& .MuiStepLabel-label, & .MuiStepIcon-text': {
              fontWeight: 'bold',
            },
          }}
        >
          {steps.map((step) => {
            return (
              <Step key={step.label}>
                <StepLabel
                  sx={{
                    fontWeight: 'bold',
                    '& .Mui-active, & .Mui-completed': {
                      fontWeight: 'bold',
                    },
                  }}
                >
                  {step.label}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
}
